import { createCheckoutSession } from '@/requests';
import {
  Anchor,
  Container,
  Group,
  Image,
  rem,
  Switch,
  useMantineColorScheme,
  useMantineTheme,
} from '@mantine/core';
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { IconMoon, IconSun } from '@tabler/icons-react';
import { useCallback } from 'react';
import { useSearchParams } from 'react-router-dom';

const stripePromise = loadStripe(
  'pk_live_51NuWRXC1ZokDTepruWp7XedCkDWDSnDantPfHEM0LxlmFCYSdv0C0t5YS8SxknuitTLNSM8dtgA9mM2HewV54Ech00R8FzAZTU'
);

export function CheckoutForm() {
  const { colorScheme, setColorScheme } = useMantineColorScheme();
  const theme = useMantineTheme();
  const [searchParams] = useSearchParams();

  const fetchClientSecret = useCallback(() => {
    return createCheckoutSession({
      price: searchParams.get('price'),
      email: searchParams.get('email'),
    }).then((data) => data.client_secret);
  }, []);

  const options = { fetchClientSecret };

  return (
    <>
      <Container fluid>
        <Group h={70} align="center" justify="space-between" gap="0">
          <Anchor href="/">
            <Image src="/image/slides-generator-branding.png" h={30} />
          </Anchor>
          <Group gap={0}>
            <Switch
              checked={colorScheme === 'light'}
              onChange={(event) => setColorScheme(event.currentTarget.checked ? 'light' : 'dark')}
              size="lg"
              onLabel={
                <IconSun
                  style={{ width: rem(16), height: rem(16) }}
                  stroke={2.5}
                  color={theme.colors.yellow[4]}
                />
              }
              offLabel={
                <IconMoon
                  style={{ width: rem(16), height: rem(16) }}
                  stroke={2.5}
                  color={theme.colors.blue[6]}
                />
              }
            />
          </Group>
        </Group>
      </Container>

      <Container fluid pb="lg">
        <EmbeddedCheckoutProvider stripe={stripePromise} options={options}>
          <EmbeddedCheckout />
        </EmbeddedCheckoutProvider>
      </Container>
    </>
  );
}
